import { render, staticRenderFns } from "./select_weiBo.vue?vue&type=template&id=b383f2c8&scoped=true&"
import script from "./select_weiBo.vue?vue&type=script&lang=js&"
export * from "./select_weiBo.vue?vue&type=script&lang=js&"
import style0 from "./select_weiBo.vue?vue&type=style&index=0&id=b383f2c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b383f2c8",
  null
  
)

export default component.exports